module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7n6r5n1r-233aee305cb685db588da1d12d628711.svg";